import { render, staticRenderFns } from "./AnularReserva.vue?vue&type=template&id=12edcb94&scoped=true&"
import script from "./AnularReserva.vue?vue&type=script&lang=ts&"
export * from "./AnularReserva.vue?vue&type=script&lang=ts&"
import style0 from "./AnularReserva.vue?vue&type=style&index=0&id=12edcb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12edcb94",
  null
  
)

export default component.exports